/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Img from "gatsby-image";

/**
 * Mimicking the real way our images are put together by gatsby-image
 */
const DivImg = ({ src, className, style, ...rest }) => {
  return (
    <div
      className={className}
      style={{
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: "100%",
          paddingBottom: "75%",
        }}
      ></div>
      <img
        src={src}
        {...rest}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center center",
        }}
      ></img>
    </div>
  );
};

/**
 * @typedef {object} AdditionalProps
 * @prop {Image.ImageParam | string | React.ReactElement} [src]
 * @prop {string} [publicURL]
 * @prop {string} alt Force providing an alt
 * @prop {string} [className] Force className to be a string

 * @param {Omit<Image.GatsbyImageProps, "fixed" | "fluid"> & AdditionalProps} props
 */
const Image = ({
  src: image,
  title,
  alt,
  className,
  style,
  publicURL,
  ...imageProps
}) => {
  /** If the CMS passed a prepared image element, use that */
  if (React.isValidElement(image)) {
    return image;
  }

  /** Props that are common to img and gatsby-image */
  const htmlProps = { className, style, title };

  if (typeof image === "string") {
    /** In this case, src was a URL */
    return <DivImg src={image} alt={alt} {...htmlProps} />;
  }

  if (!image) {
    return <DivImg src={publicURL} alt={alt} {...htmlProps} />;
  }

  if (image.fixed) {
    return <Img fixed={image.fixed} alt={alt} {...imageProps} {...htmlProps} />;
  } else {
    return <Img fluid={image.fluid} alt={alt} {...imageProps} {...htmlProps} />;
  }
};

export default Image;
